module.exports = __webpack_public_path__ + "img/gray-03-mini.9cce39c5.png";